/*
 * @Author: cc
 * @LastEditTime: 2023-11-15 15:40:00
 */
import { chinaProvinceData } from "@root/common/data/chinaProvinceData";
import { subjectData } from "@root/common/data/subjectData";
import { titleData } from "@root/common/data/titleData";
import { centerClassification } from "@root/common/data/centerClassification";
import { echartCityData } from "@root/common/data/echartCityData";
import { setAdvertisementData } from "@root/reducers/advertisement";
export const InitUserInfo = {
  access_token: "",
  userName: "",
  baseUserCategory: "1",
};
export interface UserDetailInfoProps {
  /**基本审核状态 0:通过 1:拒绝 2:未确认 */
  baseAuditStatus: string;
  /**职称 */
  baseHealthTitle: number;
  /**学员状态 */
  baseStuStatus: number;
  id: 35;
  /**证件类型 */
  baseUserIdCategory: string;
  /**身份证号码 */
  identityNumber: string;
  /**机构id */
  instituteId: number;
  /**机构名称 */
  instituteName: string;
  /**姓名 */
  nickName: string;
  /**手机号 */
  phonenumber: string;
  /**拒绝原因 */
  returnReason: null | "";
  /**性别 */
  sex: string;
  /**学科 */
  subjectId: number;
  /**用户id */
  userId: number | null;
  /**流程状态 */
  flowType: string;
  /**出生日期 */
  birthday: string;
  /**账户 
   *  normal("0","正常/启用"),
			stop("1","停用"),
			notEnabled("2","未启用"),
			update("3","启用修改"),
			out("4","调出");

  */
  status: string;
  //保存的所在中心
  baseCenterCategoryList: number[];
}
export interface UserProps {
  /**登陆成功的token */
  access_token?: string;
  /**机构id */
  instituteId?: number;
  /**用户姓名 */
  userName?: string;
  /**  基本用户类型
   *  1	超级管理员
      2	普通角色
      10	全国级
      11	省级
      12	县医院
      13	支援医院
      14	培训角色
      15	市级
      16	专家
   */
  baseUserCategory?: string;
  /**可以切换的用户类型 */
  roleMap?: string[];
  /**用户信息详情 */
  userDetailInfo?: UserDetailInfoProps;
  /** 公共搜索*/
  publicSearchKey?: string;
  /** 基本注册状态*/
  baseRegistrationStatus?: string;
  /**用户ID */
  userId?: string;
  /** 省份code码*/
  provinceCode?: string;
  // 2非千县工程 0是
  isCountyProject?: string;
  /**是否是主账号 0主账号 2不是主账号 */
  mainFlag?: string;
  uumsId?: string;
}

export const InitvideoState = {
  /**视频id */
  vid: "2D38764E9B7706947E6C9CEE8B422289",
  /**ccUserId */
  siteid: "AA247F3728571B49",
  /**是否允许拖拽 */
  progressbar_enable: 1,
  /**ccUserId */
  rate_allow_change: true,
  /**防多开 */
  preventOnHookFlag: 0,
  /**随机暂停次数 */
  randomPopUpNum: 0,
  /**防挂机提示信息 */
  onHookTipInfo: "辛苦，请继续观看！",
  /**视频播放时长 */
  videoDuration: 0,
  /**观看开始时间 */
  watchStartTime: 0,
  /**课程id */
  courseId: 0,
  /**课件id */
  sectionId: 0,
  /**当前观看位置 */
  watchAt: 0,
  /**需要记录 */
  needRecord: true,
  /**视频名称 */
  name: "",
};
export type VideoProps = Partial<typeof InitvideoState> &
  Required<{
    /**视频id */
    vid: string;
    /**账号id */
    siteid: string;
    /**是否需要记录 */
    needRecord: boolean;
  }>;

export const InitGlobalSpin = {
  loading: false,
};

export interface MenuColumnIdProps {
  // 菜单栏目id
  columnId: number;
}
export const InitMenuColumnId = {
  /**视频id */
  columnId: 0,
};

export type IGlobalSpinProp = typeof InitGlobalSpin;

export const InitDictionariesdata = {
  /** 省份*/
  chinaProvinceData,
  /** 学科*/
  subjectData,
  /** 职称*/
  titleData,
  /** 中心分类*/
  centerClassification,
  /** echart地图映射*/
  echartCityData,
};
type instituteListProps = {
  // 机构数据
  instituteList: Array<{
    /**机构id */
    id: number;
    /**机构名称 */
    name: string;
  }>;
};

export interface ChinaProvincePorps {
  value: string;
  label: string;
  children?: ChinaProvincePorps[];
}

export type InitDictionariesdataProps = Partial<instituteListProps> &
  typeof InitDictionariesdata;
export interface advertisementDataProps {
  //首页banner广告
  xy_home_banner: any[];
  // 导航页
  xy_navigation: any[];
  // 首页底部广告
  xy_home_bottom: any[];
  //首页侧边广告图
  xy_home_erect: any[];
  // 县域-首页弹窗广告
  xy_home_pop: any[];
  // 县域-首页飘窗广告
  xy_home_slip: any[];
  //县域-登录页广告
  xy_home_login: any[];
  //县域-视频底部广告
  xy_video_bottom: any[];
}

export const InitAdvertisementData = {
  //banner广告
  xy_home_banner: [],
  // 导航页
  xy_navigation: [],
  //首页侧边广告图
  xy_home_erect: [],
  // 县域-首页-底部广告部
  xy_home_bottom: [],
  // 县域-首页弹窗广告
  xy_home_pop: [],
  // 县域-首页飘窗广告
  xy_home_slip: [],
  //县域-登录页广告
  xy_home_login: [],
  //县域-视频底部广告
  xy_video_bottom: [],
};

export const initBannerUrl = {
  url: "",
  title: "",
};
export interface BannerProps {
  url: string;
  title: string;
}
